import { defineComponent as _defineComponent } from 'vue'
import { computed, useAttrs, useListeners } from 'vue';
  import { INSPECTION_ITEM_TYPE } from '@/_legacy/constants';
  import ConductInspectionItemSection from '@/_legacy/components/ConductInspection/ConductInspectionItem/ConductInspectionItemSection.vue';
  import ConductInspectionItemQuestion from '@/_legacy/components/ConductInspection/ConductInspectionItem/ConductInspectionItemQuestion.vue';
  import ConductInspectionItemConditional from '@/_legacy/components/ConductInspection/ConductInspectionItem/ConductInspectionItemConditional.vue';
  import ConductInspectionItemAction from '@/_legacy/components/ConductInspection/ConductInspectionItem/ConductInspectionItemAction.vue';
  import ConductInspectionItemUnknown from '@/_legacy/components/ConductInspection/ConductInspectionItem/ConductInspectionItemUnknown.vue';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'ConductInspectionItem',
  props: {
    entities: {
      type: Object,
      required: true,
    },
    item: {
      type: Object,
      required: true,
    },
    previewMode: {
      type: [Boolean, String],
      default: false,
    },
  },
  setup(__props) {

const props = __props;

  

  const attrs = useAttrs();
  const boundProps = computed(() => ({ ...attrs, ...props }));
  const listeners = useListeners();

  const componentMap = {
    [INSPECTION_ITEM_TYPE.SECTION]: ConductInspectionItemSection,
    [INSPECTION_ITEM_TYPE.QUESTION]: ConductInspectionItemQuestion,
    [INSPECTION_ITEM_TYPE.CONDITIONAL]: ConductInspectionItemConditional,
    [INSPECTION_ITEM_TYPE.ACTION]: ConductInspectionItemAction,
  } as const;

  const componentToRender = computed(() => {
    return componentMap[props.item.type as keyof typeof componentMap] || ConductInspectionItemUnknown;
  });

return { __sfc: true,props, attrs, boundProps, listeners, componentMap, componentToRender }
}

})